import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import PrivateLayout from '@/components-latest/layout/PrivateLayout'
import PublicLayout from '@/components-latest/layout/PublicLayout'
import BootErrorScreen from '@/components-latest/primitives/BootErrorScreen'
import SplashScreen from '@/components-latest/primitives/SplashScreen'
import ProtectedRoute from '@/components-latest/shared/ProtectedRoute'
import routeConfigs, { RouteConfig } from '@/config/router/routes'
import {
  selectBootStatus,
  selectIsAppInitialized
} from '@/ducks/app/selectors/app.selectors'

const applyRouteConfig = (config: RouteConfig) => {
  if (config.clearLayout) {
    return (
        // @ts-ignore
        <Route
          key={config.path}
          path={config.path}
          exact={config.exact}
          render={() => <>{config.element}</>}
        />
    )
  }

  if (config.isProtected) {
    const Component = config?.forcePublicLayout ? PublicLayout : PrivateLayout
    return (
        // @ts-ignore
        <Route
          key={config.path}
          path={config.path}
          exact={config.exact}
          render={() => (
            <ProtectedRoute
              element={<Component>{config.element}</Component>}
              requiredPermission={config.requiredPermission}
            />
          )}
        />
    )
  }

  return (
    // @ts-ignore
    <Route
      key={config.path}
      path={config.path}
      exact={config.exact}
      render={() => <PublicLayout>{config.element}</PublicLayout>}
    />
  )
}

const routeComponents = routeConfigs.map(applyRouteConfig)

const RouteManager = () => {
  const isAppInitialized = useSelector(selectIsAppInitialized)
  const bootStatus = useSelector(selectBootStatus)
  const hasBootFailed = bootStatus === 'failed'

  return (
    <>
      {hasBootFailed && <BootErrorScreen />}
      {!isAppInitialized && !hasBootFailed && <SplashScreen />}
          <Switch>{routeComponents}</Switch>
    </>
  )
}

export default RouteManager
